export const checkboxToggler = <T>(
  options: T[],
  selectedOption: T | 'all',
  allOptions: T[]
): T[] => {
  if (selectedOption === 'all') {
    return options.length === allOptions.length ? [] : allOptions
  }

  if (options.includes(selectedOption)) {
    return options.filter((option) => option !== selectedOption)
  }

  return [...options, selectedOption]
}
